export const removePunctuationMarks = (source: string): string => {
    return source.replace(/[\.\,\\\/\:\:]/, "");
};
